import React from 'react';
import { MapPin } from 'lucide-react';
export const CoverageStrip = () => {
  return <div className="bg-blue-500 text-white py-8" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8" data-id="element-57">
          <div className="flex items-center space-x-3" data-id="element-58">
            <MapPin className="w-8 h-8" data-id="element-59" />
            <div data-id="element-60">
              <h3 className="text-xl font-bold" data-id="element-61">UK Mainland Coverage</h3>
              <p className="text-blue-100" data-id="element-62">
                Professional repairs across England, Scotland, Wales
              </p>
            </div>
          </div>
          <a href="tel:08000554969" className="bg-white text-blue-600 px-6 py-3 rounded-lg hover:bg-slate-100 transition-colors font-semibold" data-id="element-63">
            Call 0800 055 4969
          </a>
        </div>
      </div>
    </div>;
};